import CompanyMobileMeals from "./mobile/screens/CompanyMobileMeals.vue";
import CompanyMobileMealEmployees from "./mobile/screens/CompanyMobileMealEmployees.vue";
import CompanyMobileEmployees from "./mobile/screens/CompanyMobileEmployees.vue";
import CompanyMobileOrdered from "./mobile/screens/CompanyMobileOrdered.vue";
import CompanyMobileReserved from "./mobile/screens/CompanyMobileReserved.vue";
import CompanyMobileTakenMeals from "./mobile/screens/CompanyMobileTakenMeals.vue";
import CompanyMobileTaken from "./mobile/screens/CompanyMobileTaken.vue";
import CompanyMobileTakenCompany from "./mobile/screens/CompanyMobileTakenCompany.vue";
import CompanyMobileGroupEmployees from "./mobile/screens/CompanyMobileGroupEmployees.vue";
import CompanyMobileGroupOrdered from "./mobile/screens/CompanyMobileGroupOrdered.vue";
import CompanyMobileGroupOrderers from "./mobile/screens/CompanyMobileGroupOrderers.vue";
import CompanyMobileGroupGrouped from "./mobile/screens/CompanyMobileGroupGrouped.vue";
import CompanyMobileMultiMeals from "./mobile/screens/multi/CompanyMobileMultiMeals.vue";
import CompanyMobileMultiRestaurantMeals from "./mobile/screens/multi/CompanyMobileMultiRestaurantMeals.vue";
import CompanyMobileMultiPackages from "./mobile/screens/multi/CompanyMobileMultiPackages.vue";
import CompanyMobileMultiEmployees from "./mobile/screens/multi/CompanyMobileMultiEmployees.vue";
import CompanyMobileMultiEmployeeMealSummary from "./mobile/screens/multi/CompanyMobileMultiEmployeeMealSummary.vue";
import CompanyMobileMultiRestaurantSummary from "./mobile/screens/multi/CompanyMobileMultiRestaurantSummary.vue";
import CompanyMobileMultiCreditUsers from "./mobile/screens/multi/CompanyMobileMultiCreditUsers.vue";
import CompanyMobileMultiTopup from "./mobile/screens/multi/CompanyMobileMultiTopup.vue";
import CompanyMobileMultiCreditTopups from "./mobile/screens/multi/CompanyMobileMultiCreditTopups.vue";
import ReportMobileEmployee from "../report/mobile/screens/ReportMobileEmployee.vue";

export const EMPLOYEE_SCREEN = "employee";

/**
 * Izveštaji firme na telefonu. `shifts`: ekran poštuje izbor smena; `headerSearch`: lupa u zaglavlju;
 * `noExport`: nema štampe ni Excela (stari tab ih nema); `usersFeed`: ekran dobija radnike (`users`, `loading`) od
 * ljuske umesto da ih sam učitava; `noCompanies`: izveštaj ne zavisi od izbora firmi/restorana; `userPreselect`: ekran
 * dobija `preselectedUserId`; `header: "form"`: unos (bez perioda i filtera u zaglavlju), `hint` je njegov opis.
 * Obična firma, firma tipa "grupa" i firma "više restorana" imaju svoje skupove izveštaja (`variant`).
 */
const buildPlainScreens = (t) => ({
  meals: {
    title: t("meals"),
    subtitle: t("company_report.hints.meals"),
    icon: "mdi-clipboard-list-outline",
    component: CompanyMobileMeals,
    shifts: true,
    headerSearch: true,
  },
  mealEmployees: {
    title: t("meal_worker"),
    subtitle: t("company_report.hints.meal_employees"),
    icon: "mdi-format-list-bulleted-type",
    component: CompanyMobileMealEmployees,
    headerSearch: true,
  },
  employees: {
    title: t("employees"),
    subtitle: t("company_report.hints.employees"),
    icon: "mdi-account-outline",
    component: CompanyMobileEmployees,
    headerSearch: true,
  },
  ordered: {
    title: t("ordered_1"),
    subtitle: t("company_report.hints.ordered"),
    icon: "mdi-grid",
    component: CompanyMobileOrdered,
    shifts: true,
    headerSearch: true,
  },
  reserved: {
    title: t("r_o"),
    subtitle: t("company_report.hints.reserved"),
    icon: "mdi-archive-outline",
    component: CompanyMobileReserved,
    headerSearch: true,
    noExport: true,
  },
  takenMeals: {
    title: t("t_o"),
    subtitle: t("company_report.hints.taken_meals"),
    icon: "mdi-check-circle-outline",
    component: CompanyMobileTakenMeals,
    shifts: true,
    headerSearch: true,
  },
  taken: {
    title: t("taken"),
    subtitle: t("company_report.hints.taken"),
    icon: "mdi-truck-outline",
    component: CompanyMobileTaken,
    shifts: true,
    headerSearch: true,
  },
  takenCompany: {
    title: t("company_report.taken_company"),
    subtitle: t("company_report.hints.taken_company"),
    icon: "mdi-domain",
    component: CompanyMobileTakenCompany,
    shifts: true,
    headerSearch: true,
  },
});

const buildGroupScreens = (t) => ({
  groupUsers: {
    title: t("user_overview"),
    subtitle: t("report_group.hints.users"),
    icon: "mdi-account-settings",
    component: CompanyMobileGroupEmployees,
    headerSearch: true,
    usersFeed: true,
  },
  groupOrdered: {
    title: t("ordered_1"),
    subtitle: t("report_group.hints.ordered"),
    icon: "mdi-grid",
    component: CompanyMobileGroupOrdered,
    headerSearch: true,
  },
  groupOrderers: {
    title: t("orderers"),
    subtitle: t("report_group.hints.orderers"),
    icon: "mdi-format-list-bulleted-type",
    component: CompanyMobileGroupOrderers,
    headerSearch: true,
  },
  groupGrouped: {
    title: t("groups_meal"),
    subtitle: t("report_group.hints.grouped"),
    icon: "mdi-food",
    component: CompanyMobileGroupGrouped,
    shifts: true,
  },
});

/** Firma "više restorana": "firme" su restorani, a krediti radnika (dopuna, korisnici, istorijat) su deo izveštaja. */
const buildMultiScreens = (t) => ({
  meals: {
    title: t("meals"),
    subtitle: t("company_report.multi_hints.meals"),
    icon: "mdi-silverware-fork-knife",
    component: CompanyMobileMultiMeals,
    shifts: true,
    headerSearch: true,
  },
  restaurantMeals: {
    title: t("restaurant_meals"),
    subtitle: t("company_report.multi_hints.restaurant_meals"),
    icon: "mdi-package-variant",
    component: CompanyMobileMultiRestaurantMeals,
    shifts: true,
    headerSearch: true,
  },
  packing: {
    title: t("pak"),
    subtitle: t("company_report.multi_hints.packing"),
    icon: "mdi-shopping-outline",
    component: CompanyMobileMultiPackages,
    headerSearch: true,
  },
  employees: {
    title: t("employees"),
    subtitle: t("company_report.hints.employees"),
    icon: "mdi-account-outline",
    component: CompanyMobileMultiEmployees,
    shifts: true,
    headerSearch: true,
  },
  employeeMealSummary: {
    title: t("employee_meal_summary"),
    subtitle: t("company_report.multi_hints.meal_summary"),
    icon: "mdi-account-cash-outline",
    component: CompanyMobileMultiEmployeeMealSummary,
    headerSearch: true,
  },
  restaurantSummary: {
    title: t("restaurant_summary"),
    subtitle: t("company_report.multi_hints.restaurant_summary"),
    icon: "mdi-chart-bar",
    component: CompanyMobileMultiRestaurantSummary,
  },
  creditUsers: {
    title: t("credit_users"),
    subtitle: t("company_report.multi_hints.credit_users"),
    icon: "mdi-account-cash-outline",
    component: CompanyMobileMultiCreditUsers,
  },
  addCredit: {
    title: t("add_credit"),
    subtitle: t("company_report.topup.hint"),
    hint: t("company_report.topup.hint"),
    icon: "mdi-cash-plus",
    component: CompanyMobileMultiTopup,
    header: "form",
    noExport: true,
    userPreselect: true,
    noCompanies: true,
  },
  creditTopups: {
    title: t("credit_topups"),
    subtitle: t("company_report.multi_hints.credit_topups"),
    icon: "mdi-credit-card-check-outline",
    component: CompanyMobileMultiCreditTopups,
    noCompanies: true,
  },
});

/** Skup izveštaja varijante: "canteen" (stranica "Izveštaj kantina") ima samo Radnike i Preuzete obroke. */
const buildVariantScreens = (t, variant) => {
  if (variant === "group") {
    return buildGroupScreens(t);
  }
  if (variant === "multi") {
    return buildMultiScreens(t);
  }
  const plain = buildPlainScreens(t);
  return variant === "canteen" ? { employees: plain.employees, takenMeals: plain.takenMeals } : plain;
};

/**
 * @param {(key: string, params?: object) => string} t prevod
 * @param {{ fullName?: string }|null} employee radnik otvoren u mesečnom pregledu
 * @param {"plain"|"group"|"multi"|"canteen"} variant obična firma, firma tipa "grupa", firma "više restorana" ili
 *   stranica "Izveštaj kantina"
 */
export const buildCompanyScreens = (t, employee = null, variant = "plain") => ({
  ...buildVariantScreens(t, variant),
  /** Nije u meniju: otvara se iz liste radnika (store: report/selectedEmployee). */
  [EMPLOYEE_SCREEN]: {
    title: (employee && employee.fullName) || t(variant === "group" ? "user_overview" : "employees"),
    component: ReportMobileEmployee,
    header: "worker",
    noExcel: true,
  },
});

export { buildCompanyMenu } from "./companyReportMenu";
